// TikTok Pixel conversion event for the Message Ori handoff actions.
//
// The pixel itself is loaded (or not) by the host-gated snippet in
// index.html; on dev/preview hosts `window.ttq` is simply absent and this
// is a no-op. All three handoff actions (Open Messages / copy number /
// copy message) report the SAME standard `Contact` event so the volume
// stays on one Ads Manager optimization goal — the per-action split lives
// in our own /api/web-events telemetry, not in TikTok.
//
// `event_id` future-proofs deduplication if we ever mirror the event
// through the server-side Events API.

type Ttq = { track?: (event: string, props?: object, opts?: object) => void };

export function trackTikTokContact(): void {
  const ttq = (window as unknown as { ttq?: Ttq }).ttq;
  if (!ttq || typeof ttq.track !== 'function') return;
  try {
    ttq.track(
      'Contact',
      { content_name: 'message_ori' },
      { event_id: crypto.randomUUID() },
    );
  } catch {
    /* analytics must never break the handoff UX */
  }
}
